module.exports = __webpack_public_path__ + "static/media/1018875.69270f56.jpg";